import moment from 'moment'
import React, { useContext } from 'react'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import GeoContext from 'contexts/geoContext'
import useTourV2SnapshotDetails from 'hooks/TourV2/useTourV2SnapshotDetails'
import { formatDynamicAmountWithDollarType } from 'lib/format/formatCurrencyIntl'
import { extractOfferIdsFromOrder } from 'tripPlanner/components/EntryPoints/utils'
import BookingItemCard from 'tripPlanner/components/ItemCard/BookingItemCard'
import { OfferTypeForTripItemTypes } from 'tripPlanner/hooks/api/common'
import { concatStringWithDot } from 'tripPlanner/utils'
import useOffers from 'hooks/Offers/useOffers'
import useTourV2Snapshot from 'hooks/TourV2/useTourV2Snapshot'

type Props = {
  order: App.Order
  tourV2OrderItem: App.Tours.TourV2OrderItem
  onSelect?: (
    order: App.Order,
    offers: Array<OfferTypeForTripItemTypes>,
    checked: boolean,
  ) => void
}

function TourV2BookingCard(props: Props) {
  const { tourV2OrderItem, onSelect, order } =
    props
  const { currentCurrency, currentRegionCode } = useContext(GeoContext)
  const [offers, isOffersLoading] = useOffers(extractOfferIdsFromOrder(order))
  const [snapshot, isSnapshotLoading] = useTourV2Snapshot(tourV2OrderItem.reservationId)

  const { formattedEndDate, formattedStartDate } =
    useTourV2SnapshotDetails(snapshot)

  const renderStartAndEndDate = () => {
    return `${moment(formattedStartDate).format('DD MMM')} - ${moment(
      formattedEndDate,
    ).format('DD MMM YYYY')}`
  }

  const isLoading = isOffersLoading || isSnapshotLoading

  if (isLoading) {
    return <LoadingIndicator inline />
  }

  return (
    <BookingItemCard
      heading={tourV2OrderItem.tour.tourOptionTitle}
      image={{ id: snapshot?.imageId }}
      subHeading={concatStringWithDot(
        renderStartAndEndDate(),
        formatDynamicAmountWithDollarType(
          tourV2OrderItem.total,
          currentCurrency,
          currentRegionCode,
        ),
      )}
      onSelect={(checked) => {
        if (onSelect) {
          onSelect(order, offers, checked)
        }
      }}
    />
  )
}

export default TourV2BookingCard
